module.exports = __webpack_public_path__ + "img/contract_company.88e468b6.png";